module.exports = __webpack_public_path__ + "static/logo_basico-ef9d8838067bde163dc7b6bc5e8ca25b.png";